import React, { useState } from 'react';
import Homepage from './components/Homepage';
import ImageCreator from './components/ImageCreator';
import ImageUploadTransform from './components/ImageUploadTransform';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return (
          <Homepage 
            onNavigateToCreate={() => setCurrentPage('create')}
            onNavigateToUpload={() => setCurrentPage('upload')}
            onNavigateToGallery={() => setCurrentPage('gallery')}
          />
        );
      case 'create':
        return <ImageCreator onBack={() => setCurrentPage('home')} />;
      case 'upload':
        return <ImageUploadTransform onBack={() => setCurrentPage('home')} />;
      default:
        return (
          <Homepage 
            onNavigateToCreate={() => setCurrentPage('create')}
            onNavigateToUpload={() => setCurrentPage('upload')}
            onNavigateToGallery={() => setCurrentPage('gallery')}
          />
        );
    }
  };

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;